import BasePage from '../../../../../components/table_page';
import adjustmentForm from './adjustment';
import detailForm from './detail';

export default {
  name: 'wine_mixing_pool',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    adjustmentForm,
    detailForm,
  },
  created() {
    this.getConfigList('tpm_wine_mixing_pool_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
      if (val.code === 'adjustment') {
        this.formName = 'adjustmentForm';
        this.modalConfig.title = '调整';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.openFull();
      }
      if (val.code === 'check_detail') {
        this.formName = 'detailForm';
        this.modalConfig.title = '查看明细';
        this.propsObjInData.row = row;
        this.openFull();
      }
    },
  },
};
